import React, { useEffect, useState } from 'react'
import { Search, X, Check } from 'lucide-react'
import { translations } from '../../utils/constants'
import { useDispatch } from 'react-redux'
import { setPanelCount } from '../../Redux/actions/panelAction'

const SearchPanel = ({ selectedClients, handleClientChange, clients, setSearchModal, searchModal, language }) => {
const dispatch = useDispatch()
    const [searchQuery, setSearchQuery] = useState('')
    const [selectedItems, setSelectedItems] = useState(selectedClients || [])

    useEffect(() => {
        dispatch(setPanelCount(selectedItems?.length || 0))
    }, [selectedItems, dispatch])

    useEffect(() => {
        if (!searchModal) {
            setSearchQuery('')
        }
    }, [searchModal])

    const filteredClients = clients?.filter(c =>
        c?.client?.toLowerCase()?.includes(searchQuery.toLowerCase())
    )

    const handleSelection = (clientObj) => {
        const isSelected = selectedItems.some(i => i.value === clientObj.value)

        let updated;

        if (isSelected) {
            updated = selectedItems.filter(i => i.value !== clientObj.value)
        } else {
            updated = [...selectedItems, clientObj]
        }

        setSelectedItems(updated)
        handleClientChange(updated)
    }

    // Select all
    const handleSelectAll = () => {
        if (selectedItems?.length > 1) {
            setSelectedItems([])
            handleClientChange([])
        }
        else {
            const allClients = clients || []
            setSelectedItems(allClients)
            handleClientChange(allClients)
        }
    }

    return (
        <div className='search-organization-container'>
            <span className='close-icon-search' onClick={() => setSearchModal(false)}>
                <X />
            </span>

            <div className='search-organization-header'>
                <h1>{translations[language]?.client || "Client"}</h1>
            </div>

            <div className='search-inner-div search-input-div2' style={{ margin: '0px' }}>
                <Search className='search-icon' />
                <input
                    type='text'
                    placeholder={translations[language]?.searchClient || "Search Client"}
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className='search-input'
                />
            </div>

            <div className='organizations-header'>
                <div className='organization-search-text'>
                    {translations[language]?.client || "Client"}
                </div>

                <div onClick={handleSelectAll} className='select-all-button'>
                    {selectedItems?.length > 1
                        ? translations[language]?.clearAll
                        : translations[language]?.selectAll}
                </div>
            </div>

            <div className='organizations-list-div'>
                <div className='organizations-list'>
                    {filteredClients?.map((item, index) => (
                        <div
                            key={index}
                            onClick={() => handleSelection(item)}
                            className={`organization-item ${selectedItems.some(i => i.value === item.value) ? 'selected' : ''
                                }`}
                        >
                            <div className='checkbox'>
                                {selectedItems.some(i => i.value === item.value) && (
                                    <Check className='check-icon' />
                                )}
                            </div>

                            <div className='organization-name capitalized-name'>
                                {item.client}
                            </div>
                        </div>
                    ))}
                </div>

                {filteredClients?.length === 0 && (
                    <div className='no-results'>
                        {translations[language]?.noClientFound || "No clients found"}
                    </div>
                )}
            </div>
        </div>
    )
}

export default SearchPanel